export default __webpack_public_path__ + "static/media/bg-halopagi-4.46757676.png";